import { useEffect } from "react";

const TAWK_SCRIPT_ID = "tawk-to-widget-script";

function TawkToWidget() {
  useEffect(() => {
    if (typeof window === "undefined" || typeof document === "undefined") {
      return undefined;
    }

    if (document.getElementById(TAWK_SCRIPT_ID)) {
      return undefined;
    }

    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    const script = document.createElement("script");
    script.id = TAWK_SCRIPT_ID;
    script.async = true;
    script.src = "https://embed.tawk.to/6a0895e309cffa1c3705dcd3/1joooj0cq";
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");

    const firstScript = document.getElementsByTagName("script")[0];
    firstScript?.parentNode?.insertBefore(script, firstScript);

    return undefined;
  }, []);

  return null;
}

export default TawkToWidget;
